import styled from 'styled-components';
import { rgba } from 'polished';

import { cCC38FF } from '#/colors';

import toast from '#/components/common/toast';
import Tooltip from '#/components/shared/Tooltip';

import { OpenPositionView } from '#/features/perpetuals/open-positions-context';
import { useClosePosition } from '#/features/perpetuals/trade-overview/close-position';
import { useTranslation } from '#/features/localization/utils';

export default function ClosePosition({ id }: Pick<OpenPositionView, 'id'>) {
  const { actions, view } = useClosePosition(id);
  const { t } = useTranslation();

  const onClick = () => {
    if (view.status === 'busy') return;

    actions.submit((result) => {
      if (!result.ok) toast.error(result.reason);
    });
  };

  if (view.status === 'busy') {
    return <Button disabled>{t('Market')}</Button>;
  }

  return (
    <Tooltip label={view.helperText}>
      <Button onClick={onClick}>{t('Market')}</Button>
    </Tooltip>
  );
}

const Button = styled.button.attrs({ type: 'button' })`
  align-items: center;
  background: ${rgba(cCC38FF, 0.2)};
  border-radius: 6px;
  border: 1px solid ${cCC38FF};
  color: ${cCC38FF};
  cursor: pointer;
  display: grid;
  font-size: 11px;
  font-weight: 500;
  height: 23px;
  width: 60px;

  &:hover {
    background: ${rgba(cCC38FF, 0.3)};
  }

  &:active {
    background: ${rgba(cCC38FF, 0.4)};
  }

  &:disabled {
    background: ${rgba(cCC38FF, 0.1)};
    border: none;
    color: ${rgba(cCC38FF, 0.5)};
    cursor: progress;
  }
`;
